exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".login-spinner {\n  text-align: left;\n  margin-top: 6px; }\n\n.login-button {\n  float: left; }\n\n.login-wrapper .info-text {\n  color: #565656;\n  font-size: 13px; }\n\n.login-wrapper .title .tm-icon {\n  vertical-align: super; }\n\n.remote-plugin-session-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/auth/login.component.scss
// module id = 6c+2
// module chunks = 0